// extracted by mini-css-extract-plugin
export var logo = "_bv-2";
export var logoWrapper = "_bv-1";
export var strip = "_bv-0";